module.exports = __webpack_public_path__ + "img/ticket.46734f82.png";